import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Rider extends Phaser.GameObjects.Sprite {
    id: number;
    onTrain: boolean;
    trainPosition: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        var id = ob.properties[0].value;
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "guest" + id);
        this.id = id;
        this.name = ob.name;
        this.onTrain = false;

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }

    setTrainPosition(ob: TiledGameObject) {
        this.trainPosition = new Phaser.Geom.Point(ob.x + ob.width / 2, ob.y + ob.height / 2);
    }
}

export class Seat extends Phaser.GameObjects.Zone {
    occupied: boolean;
    
    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width/2, ob.y + ob.height/2, ob.width, ob.height);
        this.occupied = false;

        this.setRectangleDropZone(ob.width, ob.height);

        this.scene.add.existing(this);
    }
}





// WEBPACK FOOTER //
// ./src/games/TicketTakerGame/objects/Rider.ts